export default import.meta.ROLLDOWN_FILE_URL_crr8cAGQtLha1Cp5BCqX5Q